import type { DiveSiteConditions } from './public'

// Signed-in user's favorites, via the BFF (/api/user/*). The BFF forwards the SWA
// user id server-side; the browser never sends it.
const BASE = '/api/user/favorites'

export const favoritesApi = {
  async list(): Promise<DiveSiteConditions[]> {
    const res = await fetch(BASE, { headers: { Accept: 'application/json' } })
    if (res.status === 401) return []
    if (!res.ok) throw new Error(`GET ${BASE} → ${res.status}`)
    return (await res.json()) as DiveSiteConditions[]
  },
  async add(diveSiteId: string): Promise<void> {
    const res = await fetch(`${BASE}/${diveSiteId}`, { method: 'POST' })
    if (!res.ok) throw new Error(`POST ${BASE}/${diveSiteId} → ${res.status}`)
  },
  async remove(diveSiteId: string): Promise<void> {
    const res = await fetch(`${BASE}/${diveSiteId}`, { method: 'DELETE' })
    if (!res.ok) throw new Error(`DELETE ${BASE}/${diveSiteId} → ${res.status}`)
  },
}
